module.exports = __webpack_public_path__ + "static/media/Helikopter@2x.1787b474.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/03/02/assets/Helikopter@2x.jpg
// module id = 497
// module chunks = 0